import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import type { TProject } from "@/zapi-frontend/stores/project";
import {
  AppHeaderBrand,
  AppHeaderDivider,
  AppHeaderEnd,
  AppHeaderStart
} from "@/zapi-frontend/widgets/Header/ui/blocks/AppHeader";
import { ExportButton } from "./_ExportButton";
import { ProjectBreadcrumb } from "./_ProjectBreadcrumb";

export function ProjectBreadcrumbHeader({
  project,
  versionMenu,
  exportDisabled,
  end,
  onProjectNameClick
}: {
  project: TProject | null;
  versionMenu: ReactNode;
  exportDisabled: boolean;
  end?: ReactNode;
  onProjectNameClick: () => void;
}) {
  const { t } = useTranslation(["projectHome", "common"]);
  return (
    <>
      <AppHeaderStart className="gap-2 sm:gap-3">
        <AppHeaderBrand
          render={<Link to={getRouteProjects()} data-testid="header-logo-link" />}
          aria-label={t("header.brandLabel")}
          className="hidden sm:flex"
        />
        <AppHeaderDivider className="hidden sm:block" />
        {project ? (
          <ProjectBreadcrumb
            name={project.name}
            iconShape={project.iconShape}
            iconColor={project.iconColor}
            logoUrl={project.logoUrl}
            projectsLink={<Link to={getRouteProjects()} data-testid="header-back-button" />}
            onNameClick={onProjectNameClick}
            versionMenu={versionMenu}
          />
        ) : (
          <span className="typo-label-md animate-pulse text-muted-foreground">{t("common:loadingProject")}</span>
        )}
      </AppHeaderStart>
      <AppHeaderEnd>
        {project && <ExportButton disabled={exportDisabled} />}
        {end}
      </AppHeaderEnd>
    </>
  );
}
